import { useAppModals } from "../../../app/state/modalSlice/hook/use-app-modals";
import { clearAssistantsStateAction } from "../../../features/Assistants/redux/slice";
import { setIsUserInfoLoading } from "../../../features/Auth/redux/slice";
import { logout } from "../../../services/api/methods";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { multiUserApi } from "../../../shared/utils/multiUserFunctions";
import { TUserAccountActions } from "../types";

export const useAccountMenu = () => {
  const dispatch = useAppDispatch();
  const { handleOpenModal } = useAppModals();
  const handlePopoverActions = (type: TUserAccountActions) => {
    switch (type) {
      case "static_token":
        handleOpenModal("static_token_modal", null);
        return;
      case "add_user":
        handleOpenModal("add_user_modal", null);
        return;
      case "logout": {
        logout().then(() => {
          multiUserApi.removeUser();
          window.location.reload();
          dispatch(clearAssistantsStateAction());
          dispatch(setIsUserInfoLoading(false));
        });
        return;
      }
      default:
        return;
    }
  };
  return {
    handlePopoverActions,
  };
};
